/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2020, Zumper
 * @description multifamilyTourTimePicker selectors
 */

import { IntegratedTourType } from '@zcode/enums'
import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectMultifamilyTourTimePicker = (state: State) => state.multifamilyTourTimePicker

export const selectSelectedTime = compose((state) => {
  return state.selectedTime
}, selectMultifamilyTourTimePicker)

export const selectHasSelectedTime = compose((state) => state != null, selectSelectedTime)

export const selectSelectedTourType = compose((state) => {
  return state.tourType || IntegratedTourType.AGENT_GUIDED
}, selectMultifamilyTourTimePicker)

export const selectSubmitting = compose((state) => {
  return state.submitting
}, selectMultifamilyTourTimePicker)

const selectTourIntegration = compose(
  (state) => state.tourIntegration,
  selectMultifamilyTourTimePicker
)

export const selectTourIntegrationByGroupId = (state: State, groupId: number) => {
  return selectTourIntegration(state).get(groupId)
}

export const selectTourIntegrationData = compose(
  (state) => state?.integration,
  selectTourIntegrationByGroupId
)
export const selectTourIntegrationForGroupIdFetchedAt = compose(
  (state) => state?.fetchedAt,
  selectTourIntegrationByGroupId
)
export const selectFetchingTourIntegrationForGroupId = compose(
  (state) => !!state?.fetching,
  selectTourIntegrationByGroupId
)

export const selectIsFetchingAnyTourIntegration = compose((state) => {
  for (const { fetching } of state.values()) {
    if (fetching) {
      return true
    }
  }
  return false
}, selectTourIntegration)

export const selectTourAvailability = compose((state) => {
  return state?.availability
}, selectTourIntegrationByGroupId)

export const selectHasTourAvailability = compose((state) => {
  if (!state) {
    return false
  }
  for (const availability of state.values()) {
    if (availability.availableTimes?.length) {
      return true
    }
  }
  return false
}, selectTourAvailability)

const selectTourAvailabilityForType = (state: State, groupId: number, type: IntegratedTourType) => {
  return selectTourAvailability(state, groupId)?.get(type)
}

export const selectAvailableTourTimes = compose(
  (state) => state?.availableTimes,
  selectTourAvailabilityForType
)

export const selectFetchingTourAvailability = compose(
  (state) => !!state?.fetching,
  selectTourAvailabilityForType
)

export const selectTourAvailabilityFetchedAt = compose((state) => {
  return state?.fetchedAt
}, selectTourAvailabilityForType)
